export default "__VITE_ASSET__YmAROcu6__"